import { atom } from "recoil";
import {
    DASHBOARD_TABS,
    IFormValuesMsActivitiesByRegionListDashboardFilter,
    IFormValuesPendingBookingsByLocationListDashboardFilter,
    IFormValuesPendingBookingsBySegmentListDashboardFilter
} from "./types";

export const pendingBookingsByLocationFilterState = atom<IFormValuesPendingBookingsByLocationListDashboardFilter>({
    key: 'pendingBookingsByLocationListFilterState',
    default: {
        segments: [],
        categories: [],
        products: [],
        pickupLocations: []
    }
});

export const pendingBookingsBySegmentAndCategoryFilterState = atom<IFormValuesPendingBookingsBySegmentListDashboardFilter>({
    key: 'pendingBookingsBySegmentAndCategoryListFilterState',
    default: {
        pickupLocations: []
    }
});

export const mobilityStoreActivitiesByRegionFilterState = atom<IFormValuesMsActivitiesByRegionListDashboardFilter>({
    key: 'mobilityStoreActivitiesByRegionListFilterState',
    default: {
        segments: [],
        categories: [],
        products: []
    }
});

export const tabState = atom<DASHBOARD_TABS>({
    key: 'tabState',
    default: DASHBOARD_TABS.PENDING_BOOKINGS_BY_LOCATIONS,
});

export const tenantsDealersState = atom<{ tenants?: string[], dealers?: string[] }>({
    key: 'tenantsDealersState',
    default: {}
})
